import React, {Component} from "react";
import FlexView from "react-flexview";
import {connect} from "react-redux";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import SimpleUploadImage from "../../../../modules/upload/SimpleUploadImage";
import ErrorAction from "../../../../Redux/ErrorRedux";
import Api from "../../../../Services/Api";
import {DeliveryStatus, HttpStatus} from "../../../common/Constants";
import BarangLainTab from "./barangLainTab";
import HadiahTab from "./hadiahTab";
import KsuTab from "./ksuTab";
import PartsTab from "./partsTab";
import UnitTab from "./unitTab";
import * as R from "ramda";
import {fetchDataAsync} from "../../../../Services/Utils";
import M from "moment";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: false,
            showAlert: false,
            showAlertCantDeliver: false,
            showErrors: false
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getDeliveryDetail,
            menuName: "Delivery Confirmed",
            setError: this.props.setError,
            args: this.props.id,
        });
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                data: response.data.data,
            }));
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    }

    handleFinishSending = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const data = this.state.data;
        const completedDate = M(new Date()).format("DD-MM-YYYY HH:mm:ss");
        if (R.equals(data.dataUnit?.unitDeliveryStatus, DeliveryStatus.SCANNED)) {
            if (data.deliveryPhoto === null) {
                 this.setState({ showErrors: true });
                 this.handleAlertModalSaveVisibility()
            } else {
                const request = {
                    deliveryId: this.props?.id,
                    kodeCabang: this.props.kodeCabang,
                    orderH1: data.orderH1 || "",
                    pdiNo: data.pdiNo || "",
                    customerName: data.dataUnit?.namaPembeli,
                    custermerStnkName: data.customerStnkName || "",
                    variantCode: data.dataUnit?.kodeVariant,
                    idWarna: data.idWarna || "",
                    deliveryManId: data.dataDriver?.driverId,
                    deliveryCompletedDate: completedDate,
                    customerAddress: data.alamatPembeli,
                    deliveryAddress: data.alamatKirim,
                    deliveryAddressNote: data.catatanAlamat,
                    deliveryUnitStatus: data.dataUnit?.unitDeliveryStatus,
                    deliveryDoneDate: data.tanggalSelesai,
                    deliveryDoneTime: data.jamSelesai,
                    engineNumber: data.dataUnit?.nomorMesin,
                    deliveryPhoto: data?.deliveryPhoto,
                    deliveryPhotoUrl: data?.deliveryPhotoUrl,
                };
                
                let res = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_TRANSACTION").submitDeliveryData,
                    menuName: "Delivery H1",
                    setError: this.props.setError,
                    args: request,
                });
                if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                    this.props.onClickClose(null);
                }   
            }
        } else {
            const res = await Api.create("NAGAMAS_TRANSACTION").checkPDIToDeliveryItem({
                pdiNo: data.pdiNo || '',
                orderH1: data.orderH1 || '',
            })
            if(res.ok && res.data.data){
                this.setState((prevValue) => ({
                    ...prevValue,
                    showAlert: true,
                }));
            }else{
                 this.setState((prevValue) => ({
                   ...prevValue,
                   showAlertCantDeliver: true,
                 }));
            }
        }

        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleAlertModalSaveVisibility = () => {
        this.setState((prevState) => ({
          ...prevState,
          alertModalSaveVisible: !prevState.alertModalSaveVisible,
        }));
    };

    handleUpdateUnitStatus = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                dataUnit: {
                    ...prevValue.data.dataUnit,
                    unitDeliveryStatus: DeliveryStatus.SCANNED,
                },
            },
        }));
    };

    handleUploadImage = async (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                deliveryPhoto: value,
            },
        }));
    };

    getValue = (path) => {
      if (!path) return "";
      return path.split(".").reduce((acc, key) => acc?.[key], this.state.data) ?? "";
    };

    render() {
        const btnDisabled = !(R.isNil(this.state.data?.jamSelesai) || R.isNil(this.state.data?.tanggalSelesai));
        return (
            <>
                <SimpleModal
                    title="Detail Delivery"
                    visible={!!this.props.id}
                    onClickClose={() => this.props.onClickClose("")}
                    content={
                        <ModalContainer>
                            <div className="grid grid-2x grid-mobile-none gap-15px">
                                <div id="grid-1">
                                    <SimpleTextArea
                                        id="input_textarea_alamat_pembeli"
                                        name="alamatPembeli"
                                        label="Alamat Pembeli"
                                        readOnly
                                        value={this.getValue("alamatPembeli")}
                                    />
                                    <SimpleTextArea
                                        id="input_textarea_catatan_alamat"
                                        name="catatanAlamat"
                                        label="Catatan Alamat"
                                        readOnly
                                        value={this.getValue("catatanAlamat")}
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleTextArea
                                        id="input_textarea_alamat_kirim"
                                        name="alamatKirim"
                                        label="Alamat Kirim"
                                        readOnly
                                        value={this.getValue("alamatKirim")}
                                    />
                                    <SimpleInput
                                        id="input_text_nama_supir"
                                        name="dataDriver.driverName"
                                        label="Nama Supir"
                                        readOnly
                                        value={this.getValue("dataDriver.driverName")}
                                    />
                                    <FlexView style={{justifyContent: "space-between"}}>
                                        <SimpleInput
                                            id="input_text_jam_selesai"
                                            name="jamSelesai"
                                            label="Jam Selesai"
                                            readOnly
                                            value={this.getValue("jamSelesai")}
                                        />
                                        <SimpleDate
                                            id="select_date_tanggal_selesai"
                                            name="tanggalSelesai"
                                            label="Tanggal Selesai"
                                            disabled
                                            date={this.getValue("tanggalSelesai")}
                                        />
                                    </FlexView>
                                </div>
                            </div>
                            <Tabs>
                                <TabList>
                                    <Tab>Unit</Tab>
                                    <Tab>KSU</Tab>
                                    <Tab>Hadiah</Tab>
                                    <Tab>Barang Lain</Tab>
                                    <Tab>Parts</Tab>
                                    <Tab>Foto</Tab>
                                </TabList>
                                <TabPanel>
                                    <UnitTab
                                        setError={this.props.setError}
                                        id={this.props.id}
                                        viewOnly={this.props.viewOnly}
                                        kodeCabang={this.props.kodeCabang}
                                        data={this.state.data?.dataUnit}
                                        onUpdateStatus={this.handleUpdateUnitStatus}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <KsuTab data={this.state.data?.dataKSU}/>
                                </TabPanel>
                                <TabPanel>
                                    <HadiahTab data={this.state.data?.dataHadiah}/>
                                </TabPanel>
                                <TabPanel>
                                    <BarangLainTab data={this.state.data?.dataBarangLain}/>
                                </TabPanel>
                                <TabPanel>
                                    <PartsTab data={this.state.data?.dataPart}/>
                                </TabPanel>
                                <TabPanel>
                                    <SimpleUploadImage
                                        id="input_upload_foto_pengiriman"
                                        name="deliveryImage"
                                        label="Foto Pengiriman"
                                        mandatory
                                        containerclassname="width width-400px"
                                        readOnly={this.props.viewOnly}
                                        value={this.state.data?.deliveryPhoto}
                                        onChange={this.handleUploadImage}
                                        errorMessage={ this.state.showErrors && !this.state.data?.deliveryPhoto ? "Field belum diisi": ""}
                                    />
                                </TabPanel>
                            </Tabs>
                            <FlexView hAlignContent="right" className="margin-top-15px">
                                <SimpleButton disabled={btnDisabled} onClick={this.handleFinishSending}>
                                    Selesai Kirim
                                </SimpleButton>
                            </FlexView>
                        </ModalContainer>
                    }
                />
                {this.state.showAlert && (
                    <SimpleAlert
                        title="Information"
                        visible={this.state.showAlert}
                        onClickClose={() => this.setState((prevValue) => ({...prevValue, showAlert: false}))}
                        content={"Unit belum di scan, silahkan scan unit terlebih dahulu."}
                    />
                )}
                {this.state.showAlertCantDeliver && (
                    <SimpleAlert
                        title="Information"
                        visible={this.state.showAlertCantDeliver}
                        onClickClose={() => this.setState((prevValue) => ({...prevValue, showAlertCantDeliver: false}))}
                        content={"Data sudah pernah disubmit"}
                    />
                )}
                {this.state.alertModalSaveVisible && (
                  <SimpleAlert
                    title={"Peringatan!"}
                    content={"Terdapat data yang belum lengkap, mohon periksa kembali"}
                    visible={this.state.alertModalSaveVisible}
                    onClickClose={this.handleAlertModalSaveVisibility}
                    additionalButtons={
                      <FlexView>
                        <SimpleButton
                          type="button"
                          text="OK"
                          onClick={() => this.handleAlertModalSaveVisibility()}
                        />
                      </FlexView>
                    }
                  />
                )}
                {<SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(Detail);
